<template>
  <v-overlay :value="$store.state.loader" z-index="9999">
    <div class="text-center">
      <v-progress-circular indeterminate size="64" color="primary" width="6"></v-progress-circular>
      <v-row class="mt-4">
        <v-col cols="12">
          <span class="text-h6 white--text">{{ $store.state.loaderText }}</span>
        </v-col>
      </v-row>
    </div>
  </v-overlay>
</template>

<script>
export default {
  name: "loader",
};
</script>

<style></style>
